export const IMAGE_TYPE = {
  SMALL: "small",
  DEFAULT: "default",
  FULL: "full",
};
export const SHADOW_TYPE = {
  NONE: "none",
  FULL: "full",
  GRADIENT: "gradient",
};
